import React, { Component } from "react";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

class CustomTableHead extends Component {
  render() {
    return (
      <TableHead>
        <TableRow>
          {this.props.column.map((column, index) => (
            <TableCell
              key={index}
              align="center"
              style={{ fontWeight: "bold" }}
            >
              {column.name}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
}

export default CustomTableHead;
